import { render, staticRenderFns } from "./user-followup-6.vue?vue&type=template&id=ec21a3ea"
import script from "./user-followup-6.vue?vue&type=script&lang=js"
export * from "./user-followup-6.vue?vue&type=script&lang=js"
import style0 from "./user-followup-6.vue?vue&type=style&index=0&id=ec21a3ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports